export default {"src":"/_next/static/media/tiktok.feba7207.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};